<script setup>
import { useLoader } from '#/general/useLoader'
import LoadingAnimation from '#/general/LoadingAnimation'
const { message, type, visible } = useLoader()
</script>

<template lang="pug">
.appLoadingContainer(v-if="visible")
  .loadingContent
    loading-animation(:type="type")
    .appLoadingText(v-if="message") {{ message }}
</template>

<style scoped lang="sass">
.appLoadingContainer
  position: absolute
  z-index: 9999
  top: 0
  left: 0
  width: 100%
  height: 100%
  max-height: 100vh
  display: flex
  justify-content: center
  align-items: center
  background-color: #000
  opacity: 0.75
  transition: background-color 0.28s
  .loadingContent
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center
    .appLoadingText
      line-height: 1.5
      font-size: 16px
      color: white
      margin-top: 15px
      max-width: 80vw
      text-align: center
</style>
